// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageHeading_wrapper__X2Vv_","details":"PageHeading_details__k8owH","separator":"PageHeading_separator__LRWFl"};